/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { baseActions } from "document-model";
import {
  resourceInstanceConfigurationManagementActions,
  resourceInstanceInstanceManagementActions,
} from "./gen/creators.js";

/** Actions for the ResourceInstance document model */

export const actions = {
  ...baseActions,
  ...resourceInstanceInstanceManagementActions,
  ...resourceInstanceConfigurationManagementActions,
};
